module.exports = __webpack_public_path__ + "img/BRAND-02.1d9dc4f2.jpg";